"use client";

import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Visionary() {
  const [currentTime, setCurrentTime] = useState("06:00");
  useEffect(() => {
    const times = ["06:00", "09:00", "12:00", "15:00", "18:00", "21:00"];
    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % times.length;
      setCurrentTime(times[index]);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <Link className="relative min-h-screen w-full overflow-hidden text-foreground bg-muted bg-cover bg-center !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/20250519_1558_Lioness at Dawn_simple_compose_01jvmdbm9fesptmdccdgpy5hgf.png)] underline cursor-pointer" href="https://www.youtube.com/watch?v=PXohWrLjwBk&t=2259s" newTab></Link>;
}